import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Asset } from '../models/asset';
import { AssetSearchCommand } from '../models/commands/asset-search-command';

@Injectable({
  providedIn: 'root',
})
export class AssetProxyService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/asset';

  getAssets(): Observable<ApiResponse<Asset[]>> {
    return this.httpClient.get<ApiResponse<Asset[]>>(`${this.baseUrl}/all`);
  }

  getAssetById(id: string): Observable<ApiResponse<Asset>> {
    return this.httpClient.get<ApiResponse<Asset>>(`${this.baseUrl}/${id}`);
  }

  upsertAsset(asset: Asset): Observable<ApiResponse<Asset>> {
    return this.httpClient.post<ApiResponse<Asset>>(`${this.baseUrl}`, asset);
  }

  searchAssets(AssetSearchCommand: AssetSearchCommand): Observable<ApiResponse<Asset[]>> {
    return this.httpClient.post<ApiResponse<Asset[]>>(`${this.baseUrl}/search`, AssetSearchCommand);
  }
}
